import { Link } from 'react-router-dom'

type ExternalProductCardProps = {
  to: string
  title: string
  idLabel: string
  idValue: string
  statusLabel: string
  statusKind?: 'active' | 'draft'
  thumbnailUrl?: string
}

export default function ExternalProductCard({
  to,
  title,
  idLabel,
  idValue,
  statusLabel,
  statusKind = 'active',
  thumbnailUrl,
}: ExternalProductCardProps) {
  return (
    <Link
      to={to}
      className="flex gap-3 bg-white border border-gray-200 rounded-lg p-3 hover:shadow-md transition-shadow touch-target-min-44"
    >
      <div className="w-[72px] h-[72px] rounded-lg bg-gray-100 overflow-hidden flex-shrink-0">
        {thumbnailUrl ? (
          <img src={thumbnailUrl} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">No image</div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-gray-900 line-clamp-2">{title || 'Untitled'}</div>
        <div className="text-xs text-gray-500 font-mono mt-1">
          {idLabel} {idValue}
        </div>
        <span
          className={`inline-block mt-2 px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase ${
            statusKind === 'draft' ? 'bg-gray-100 text-gray-700' : 'bg-emerald-100 text-emerald-800'
          }`}
        >
          {statusLabel}
        </span>
      </div>
    </Link>
  )
}
